export default function Footer() {
  return (
    <footer className="border-t border-neutral-200 mt-16">
      <div className="max-w-6xl mx-auto px-4 py-8 text-sm text-neutral-500">
        © {new Date().getFullYear()} Shop. All rights reserved.
      </div>
    </footer>
  );
}
